import { I18nService } from 'app/services/i18n.service';
import { computed, effect, inject, Injectable, signal } from '@angular/core';
import { _ } from '@ngx-translate/core';

export enum ThemeEnum {
  light = 'light',
  dark = 'dark',
}

export const ThemesList = [
  {
    label: _('Chiaro@Tema'),
    value: ThemeEnum.light,
    icon: 'light_mode',
  },
  {
    label: _('Scuro@Tema'),
    value: ThemeEnum.dark,
    icon: 'dark_mode',
  },
];

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  I18nService = inject(I18nService);

  constructor() {
    effect(() => {
      localStorage.setItem('fluid_theme', this.theme());
      document.documentElement.classList.toggle('dark', this.theme() === ThemeEnum.dark);
    });
  }

  private _theme = signal<ThemeEnum>((localStorage.getItem('fluid_theme') as ThemeEnum) || ThemeEnum.light);
  theme = this._theme.asReadonly();

  options = this.I18nService.translateArray(ThemesList);

  isDarkMode = computed(() => this.theme() === ThemeEnum.dark);

  setTheme(theme: ThemeEnum) {
    this._theme.set(theme);
  }

  toggleTheme() {
    this._theme.update((current) => (current === ThemeEnum.light ? ThemeEnum.dark : ThemeEnum.light));
  }
}
